import { all } from 'typed-redux-saga'
import {
	newsSaga,
	ratingSaga,
	notificationListSaga,
	dictsSaga,
	tasksSaga,
	notificationPopupSaga,
	selectSaga,
	notifySaga,
	fmsUnitSaga,
	feedbackModalSaga,
	sberOprosSaga,
	dadataSaga,
	emailSaga,
	fileSaga,
	reportSaga,
	settingSaga,
	feedbackWidgetSaga,
	regionByIpSaga,
	headerReportSaga,
	userSettingSaga,
} from 'Modules'
import { socketSaga } from 'Modules/Socket'

export function* moduleSaga() {
	yield* all([
		ratingSaga(),
		newsSaga(),
		notificationListSaga(),
		dictsSaga(),
		tasksSaga(),
		notificationPopupSaga(),
		selectSaga(),
		socketSaga(),
		notifySaga(),
		fmsUnitSaga(),
		feedbackModalSaga(),
		sberOprosSaga(),
		dadataSaga(),
		emailSaga(),
		fileSaga(),
		reportSaga(),
		settingSaga(),
		feedbackWidgetSaga(),
		regionByIpSaga(),
		headerReportSaga(),
		userSettingSaga(),
	])
}
